var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrand2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 10.82C19.18 10.89 18.83 11.1 18.83 11.52C18.83 11.73 18.9 11.87 19.04 12.01C19.18 12.15 19.4 12.22 19.68 12.36L19.75 10.82Z",
    fill: "#EF4130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 28.17H19.54V33.44H22.24V28.17Z",
    fill: "#EF4130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.96 22.9C25.08 22.9 29.27 18.76 29.27 13.7C29.27 8.63999 25.08 4.42999 19.96 4.42999C14.84 4.42999 10.65 8.56999 10.65 13.7C10.65 18.83 14.85 22.9 19.96 22.9ZM24.44 12.79H26.22V14.55H24.44V12.79ZM18.05 13.98C17.06 13.49 16.7 12.86 16.7 11.94C16.7 11.52 16.77 11.1 16.91 10.75C17.19 10.05 17.76 9.55999 18.47 9.27999C18.83 9.13999 19.18 9.06999 19.61 8.99999V7.72999H20.46V8.98999C21.03 9.05999 21.53 9.12999 22.02 9.33999C22.52 9.54999 22.94 9.75999 23.3 9.89999L22.38 11.59C22.38 11.59 22.31 11.52 22.17 11.45C21.89 11.24 21.39 11.1 21.03 10.96C20.82 10.89 20.53 10.82 20.32 10.82V12.51L20.75 12.58C21.18 12.72 21.6 12.86 21.96 12.93C22.74 13.28 23.17 13.7 23.38 14.19C23.52 14.47 23.59 14.82 23.59 15.24C23.59 15.73 23.52 16.15 23.31 16.43C23.17 16.78 22.88 17.06 22.6 17.27C22.32 17.48 21.96 17.62 21.61 17.76C21.25 17.9 20.83 17.9 20.47 17.97V19.44H19.62V17.98C18.48 17.91 17.28 17.56 16.35 16.93L17.27 15.1C17.27 15.17 17.41 15.24 17.55 15.31C17.91 15.52 18.47 15.8 18.9 15.94C19.18 16.01 19.47 16.08 19.82 16.15V14.46C19.47 14.47 18.76 14.33 18.05 13.98ZM13.71 12.79H15.49V14.55H13.71V12.79Z",
    fill: "#EF4130"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.96 27.25C27.56 27.25 33.74 21.14 33.74 13.62C33.74 6.1 27.57 0 19.96 0C12.36 0 6.17999 6.11 6.17999 13.63C6.17999 21.15 12.36 27.25 19.96 27.25ZM19.96 3.59C25.57 3.59 30.19 8.08 30.19 13.7C30.19 19.32 25.57 23.74 19.96 23.74C14.35 23.74 9.72999 19.25 9.72999 13.63C9.72999 8.01 14.35 3.59 19.96 3.59Z",
    fill: "#EF4130"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.58 28.17H8.88V33.44H11.58V28.17Z",
    fill: "#EF4130"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.13 28.17H12.43V33.44H15.13V28.17Z",
    fill: "#EF4130"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.69 28.17H15.99V33.44H18.69V28.17Z",
    fill: "#EF4130"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.39 15.6C21.39 15.39 21.32 15.18 21.11 15.11C20.9 14.97 20.68 14.9 20.4 14.76V16.31C21.03 16.23 21.39 16.02 21.39 15.6Z",
    fill: "#EF4130"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 28.17H30.2V33.44H32.9V28.17Z",
    fill: "#EF4130"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03002 28.17H5.33002V33.44H8.03002V28.17Z",
    fill: "#EF4130"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.15 22.48C38.15 21.78 37.58 21.15 36.8 21.15C36.09 21.15 35.45 21.71 35.45 22.48C35.45 23.25 36.02 23.81 36.8 23.81C37.58 23.74 38.15 23.18 38.15 22.48Z",
    fill: "#EF4130"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40003 3.59002C4.40003 2.61002 3.62003 1.83002 2.62003 1.83002C1.63003 1.83002 0.840027 2.60002 0.840027 3.59002C0.840027 4.57002 1.62003 5.35002 2.62003 5.35002C3.62003 5.34002 4.40003 4.57002 4.40003 3.59002Z",
    fill: "#EF4130"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.34 28.17H26.64V33.44H29.34V28.17Z",
    fill: "#EF4130"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.79 28.17H23.09V33.44H25.79V28.17Z",
    fill: "#EF4130"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 33.44H35.1H36.38V28.17H33.75V33.44Z",
    fill: "#EF4130"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.01 34.28H21.31V39.55H24.01V34.28Z",
    fill: "#EF4130"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.57 34.28H24.87V39.55H27.57V34.28Z",
    fill: "#EF4130"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 34.28H0V39.55H2.7V34.28Z",
    fill: "#EF4130"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.67 34.28H31.97V39.55H34.67V34.28Z",
    fill: "#EF4130"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.12 34.28H28.42V39.55H31.12V34.28Z",
    fill: "#EF4130"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40 28.17H37.3V33.44H40V28.17Z",
    fill: "#EF4130"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.46 34.28H17.76V39.55H20.46V34.28Z",
    fill: "#EF4130"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79998 34.28H7.09998V39.55H9.79998V34.28Z",
    fill: "#EF4130"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54999 34.28V39.54H6.17999V34.28H4.89999H3.54999Z",
    fill: "#EF4130"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.36 34.28H10.66V39.55H13.36V34.28Z",
    fill: "#EF4130"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.91 34.28H14.21V39.55H16.91V34.28Z",
    fill: "#EF4130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand2);
export default __webpack_public_path__ + "static/media/Brand2.1f2d8835302e4e7add08294c430cf4f2.svg";
export { ForwardRef as ReactComponent };